import { useEffect } from "react";
import { useUser } from "@/api/queries/user";
import { useAuthStore } from "@/stores/auth-store";

export function useAuth() {
	const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
	const isInitialized = useAuthStore((s) => s.isInitialized);
	const rememberedEmail = useAuthStore((s) => s.rememberedEmail);
	const setAuthenticated = useAuthStore((s) => s.setAuthenticated);
	const setInitialized = useAuthStore((s) => s.setInitialized);
	const userQuery = useUser();

	useEffect(() => {
		if (userQuery.isSuccess) {
			setAuthenticated(true);
			setInitialized(true);
		} else if (userQuery.isError || userQuery.fetchStatus === "idle") {
			setAuthenticated(false);
			setInitialized(true);
		}
	}, [
		userQuery.isSuccess,
		userQuery.isError,
		userQuery.fetchStatus,
		setAuthenticated,
		setInitialized,
	]);

	return {
		user: userQuery.data ?? null,
		isAuthenticated,
		isInitialized,
		isLoading: userQuery.isLoading,
		rememberedEmail,
	};
}
